import { mapActions } from 'vuex';

function logError(error) {
  console.log('--------------------------------------------------');
  console.error(error);
  if(error.response) {
    let { method, url } = error.response.config;
    let { status } = error.response;
    console.log(`${method.toUpperCase()} : ${url}`);
    console.log(`Responded with status ${status}`)
    console.log(error.response);
  }
  console.log('--------------------------------------------------');  
}


export default  {
  data() {
    return {
      isDataLoading: false,
    }
  },

  methods: {
    ...mapActions('error', [
      'setErrModalShown',
    ]),

    REQUEST_INIT() {
      this.isDataLoading = true
    },

    REQUEST_FINALLY() {
      this.isDataLoading = false
    },

    HANDLE_ERROR_GENERIC(error) {
      this.setErrModalShown(true);
      logError(error);
    }
  },
}